<template>
<section class="border border-gray-800 p-3">
	<h3 class="text-white text-2xl font-bold uppercase">Design</h3>
    <span v-for="error in getErrors('tour_design')"
    class="mt-1 text-red-600">{{ error }}</span>

    <div class="max-w-[50%] grid grid-cols-2 gap-2">

        <div>
        <h5 class="text-white text-xs mb-2">Header font</h5>
        <select class="select-black" v-model="form.header_font">
            <option value="arial">Arial</option>
            <option value="helvetica">Helvetica</option>
            <option value="times-new-roman">Times New Roman</option>
            <option value="nunito">Nunito</option>
        </select>
        </div>

        <div>
        <h5 class="text-white text-xs mb-2">Header text color</h5>
        <div class="color-wrapper">
            <div class="input-color-container">
                <input id="header_text_color" type="color" v-model="form.header_text_color">
            </div>
            <label for="header_text_color">{{ form.header_text_color }}</label>
        </div>
        </div>

        <div>
        <h5 class="text-white text-xs mb-2">Header background color</h5>
        <div class="color-wrapper">
            <div class="input-color-container">
                <input id="header_background_color" type="color" v-model="form.header_background_color">
            </div>
            <label for="header_background_color">{{ form.header_background_color }}</label>
        </div>
        </div>

        <div>
        <h5 class="text-white text-xs mb-2">Content font</h5>
        <select class="select-black" v-model="form.content_font">
            <option value="arial">Arial</option>
            <option value="helvetica">Helvetica</option>
            <option value="times-new-roman">Times New Roman</option>
            <option value="nunito">Nunito</option>
        </select>
        </div>

        <div>
        <h5 class="text-white text-xs mb-2">Content text color</h5>
        <div class="color-wrapper">
            <div class="input-color-container">
                <input id="content_text_color" type="color" v-model="form.content_text_color">
            </div>
            <label for="content_text_color">{{ form.content_text_color }}</label>
        </div>
        </div>

        <div>
        <h5 class="text-white text-xs mb-2">Content background color</h5>
        <div class="color-wrapper">
            <div class="input-color-container">
                <input id="content_background_color" type="color" v-model="form.content_background_color">
            </div>
            <label for="content_background_color">{{ form.content_background_color }}</label>
        </div>
        </div>

    </div>

</section>
</template>

<script>
import { getErrors, slugify } from '@/Pages/GlobalHelpers';

export default {
    props: ['form'],
    mounted(){
        const theme = this.$page.props.tour.data.theme
        if(theme){
            this.form.header_font = slugify(theme.header_font);
            this.form.header_text_color = theme.header_text_color;
            this.form.header_background_color = theme.header_background_color;
            this.form.content_font = slugify(theme.content_font);
            this.form.content_text_color = theme.content_text_color;
            this.form.content_background_color = theme.content_background_color;
        }
    },
    methods:{
        getErrors:getErrors,
    }
}

</script>
